import styled from "styled-components";

export const HeroSection = styled.section`
  padding: 7rem 0 5rem;
  overflow: hidden;

  @media (max-width: 992px) {
    padding: 6rem 0 3rem;
  }
`;

export const HeroGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 3rem;
  align-items: center;

  @media (max-width: 992px) {
    grid-template-columns: 1fr;
    gap: 2rem;
  }
`;

export const HeroCopy = styled.div`
  h1 {
    font-family: "SatoshiBold", sans-serif;
    font-size: clamp(2.25rem, 4.5vw, 3.5rem);
    font-weight: 700;
    line-height: 1.15;
    color: ${(props) => props.theme.colors.balck_200};
    margin-bottom: 1.25rem;
  }

  p {
    font-family: "SatoshiRegular", sans-serif;
    font-size: 1.05rem;
    line-height: 1.65;
    color: #555;
    max-width: 34rem;
    margin-bottom: 2rem;
  }
`;

export const HeroActions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: center;

  a,
  .btn-outline {
    display: inline-block;
    text-decoration: none;
    font-family: "SatoshiBold", sans-serif;
    font-size: 0.95rem;
    font-weight: 700;
    padding: 0.75rem 1.5rem;
    border-radius: 50px;
    transition: box-shadow 0.25s ease, transform 0.25s ease;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.12);
    }
  }

  .btn-primary-dark {
    background: ${(props) => props.theme.colors.balck_200};
    color: ${(props) => props.theme.colors.white_100};
  }

  .btn-outline {
    background: transparent;
    color: ${(props) => props.theme.colors.balck_200};
    border: 2px solid ${(props) => props.theme.colors.balck_200};
  }
`;

export const HeroVisual = styled.div`
  position: relative;
  min-height: 420px;

  @media (max-width: 992px) {
    min-height: 380px;
  }
`;

export const HeroGradient = styled.div`
  position: absolute;
  inset: 5% 0;
  border-radius: 24px;
  background: radial-gradient(
      circle at 20% 30%,
      rgba(74, 147, 207, 0.35) 0%,
      transparent 50%
    ),
    radial-gradient(
      circle at 80% 20%,
      rgba(255, 180, 160, 0.45) 0%,
      transparent 45%
    ),
    radial-gradient(
      circle at 60% 80%,
      rgba(255, 150, 200, 0.35) 0%,
      transparent 50%
    ),
    linear-gradient(135deg, #f8fafc 0%, #eef6fc 100%);
  filter: blur(0px);
`;

export const FloatingCard = styled.div<{
  $variant: "light" | "dark";
  $top?: string;
  $right?: string;
  $bottom?: string;
  $left?: string;
}>`
  position: absolute;
  top: ${(p) => p.$top ?? "auto"};
  right: ${(p) => p.$right ?? "auto"};
  bottom: ${(p) => p.$bottom ?? "auto"};
  left: ${(p) => p.$left ?? "auto"};
  max-width: 220px;
  padding: 1.1rem 1.25rem;
  border-radius: 16px;
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.1);
  background: ${(p) =>
    p.$variant === "dark"
      ? p.theme.colors.balck_200
      : p.theme.colors.white_100};
  color: ${(p) =>
    p.$variant === "dark"
      ? p.theme.colors.white_100
      : p.theme.colors.balck_200};
  z-index: 2;
  animation: float 6s ease-in-out infinite;

  @keyframes float {
    0%,
    100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-8px);
    }
  }

  h3 {
    font-family: "SatoshiBold", sans-serif;
    font-size: 0.95rem;
    margin: 0 0 0.35rem;
    font-weight: 700;
  }

  .stat {
    font-family: "SatoshiBold", sans-serif;
    font-size: 2rem;
    font-weight: 700;
    line-height: 1.1;
    margin-bottom: 0.35rem;
  }

  p {
    font-family: "SatoshiRegular", sans-serif;
    font-size: 0.75rem;
    line-height: 1.4;
    margin: 0;
    opacity: ${(p) => (p.$variant === "dark" ? 0.85 : 0.75)};
  }

  @media (max-width: 600px) {
    max-width: 160px;
    padding: 0.85rem;
    font-size: 0.85rem;

    .stat {
      font-size: 1.5rem;
    }
  }
`;
